export default [
  /* -------------- 通知中心 ----------- */
  {
    path: '/notification',
    name: 'Notification',
    component: () => import(/* webpackChunkName: "personal" */ '@/views/Notification/notificationCenter'),
  },
]
